import React from 'react';
import styled from 'styled-components';
import { Box, BoxProps } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { useTranslation } from 'react-i18next';

import { SectionTitle } from 'common/components/SectionTitle';

const BaseDuplicateEmployeeMessage = (props: BoxProps) => {
    const { t } = useTranslation();

    return (
        <Box
            {...props}
            alignItems="center"
            bgcolor="primary.light"
            display="flex"
            justifyContent="space-between"
            p={5}
        >
            <div>
                <SectionTitle>{t('employee.duplicate.message1')}</SectionTitle>
                <u>{t('employee.duplicate.message2')}</u>{' '}
                {t('employee.duplicate.message3')}
            </div>
            <ArrowForwardIcon color="primary" fontSize="large" />
        </Box>
    );
};

export const DuplicateEmployeeMessage = styled(BaseDuplicateEmployeeMessage)`
    font-size: ${({ theme }) => theme.typography.body1.fontSize};
    color: ${({ theme }) => theme.palette.primary.dark};
    cursor: pointer;
    ${SectionTitle} {
        margin-bottom: ${({ theme }) => `${theme.spacing(2)}px`};
    }
`;
